export default __webpack_public_path__ + "static/media/alert-circle.be6cf9ec.svg";